import { createNetworkStatusNotifier } from '@apollo'

const notifier = createNetworkStatusNotifier(
  /*
	{
	                                      initialState: {numPendingRequests: 0},
	                                      reducers:     {
		                                      onRequest: (state, {operation}) => ({
			                                      numPendingRequests: state.numPendingRequests + 1
		                                      }),
		                                      onSuccess: (state, {operation, result}) => {
			                                      if (operation.operationName === 'products' || operation.operationName === 'groupProducts') {
				                                      setTimeout(() => {
					                                      window.dispatchEvent(new window.CustomEvent('resize'))
				                                      }, 300)
			                                      }
			                                      return ({
				                                      numPendingRequests: state.numPendingRequests - 1
			                                      })
		                                      },
		                                      onError:   (state, {operation, networkError}) => {
                                            return {
                                              numPendingRequests: state.numPendingRequests - 1,
                                              error:              {
                                                graphQLErrors: networkError.result
                                                               ? networkError.result.errors
                                                               : undefined,
                                                networkError,
                                                operation
                                              }
                                            }
		                                      },
		                                      onCancel:  (state, {operation, networkError}) => ({
			                                      numPendingRequests: state.numPendingRequests - 1
		                                      })
	                                      }
                                      }
                                      */)

export const {NetworkStatusNotifier, link: networkStatusNotifierLink} = notifier




// WEBPACK FOOTER //
// ./src/stores/apollo/NetworkStatusNotifier.tsx